import React, { Component, PropTypes } from 'react'
import { Provider } from 'react-fela'
import Helmet from 'react-helmet'
import { render } from 'fela'

import Section from '../components/Section'
import Container from '../components/Container'

import debugLayout from 'fela-plugin-debug-layout'

import renderer, { initializeRenderer } from '../utils/renderer'

const rgba = (a) => 'rgba(' + [ 255, 255, 255, a ].join(',') + ')'
const Grid = (props, context) => (
window.innerWidth >= 768 ?
  <div style={{ overflow: 'hidden', pointerEvents: 'none', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 30 }}>
    <Container flex='1 0 auto'>
      <Section
        alignSelf='stretch'
        flex
        row
        style={{ opacity: 0.1, width: '100%' }}>
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
        <Section
          alignSelf='stretch'
          flex
          style={{ borderColor: 'lightgrey', borderWidth: '0 15px', borderStyle: 'solid' }} />
      </Section>
    </Container>
  </div> : null
)

const MetaData = (props, context) => (
window.innerWidth >= 768 ? (
  <Section
    justifyContent='space-between'
    alignSelf='stretch'
    style={{ position: 'fixed', fontSize: 13, display: 'block', top: 0, left: 0, zIndex: 20, backgroundColor: 'rgba(255, 255, 255, 0.4)', padding: 5 }}>
    <button onClick={props.toggleOutlines}>
      Toggle outlines
    </button>
    <br/>
    <button onClick={props.toggleGrid}>
      Toggle grid
    </button>
  </Section>
  ) : null
)

Grid.contextTypes = { width: PropTypes.number }

MetaData.contextTypes = {
  orientation: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
}

export default class FelaProvider extends Component {
  constructor(props, context) {
    super(props, context)
    this.renderer = renderer
    initializeRenderer(this.renderer)
    this.debugLayout = debugLayout({ thickness: 2 })
    this.state = { grid: true }
    this.toggleOutlines = this.toggleOutlines.bind(this)
    this.toggleGrid = this.toggleGrid.bind(this)
  }

  componentDidMount() {
    render(this.renderer, document.getElementById('fela-stylesheet'))
  }

  toggleOutlines() {
    const index = this.renderer.plugins.indexOf(this.debugLayout)

    if (index === -1) {
      this.renderer.plugins.push(this.debugLayout)
    } else {
      this.renderer.plugins = this.renderer.plugins.filter((plug, i) => i !== index)
    }

    this.renderer.rehydrate()
  }

  toggleGrid() {
    this.setState({ grid: !this.state.grid })
  }

  render() {
    return (
      <Provider renderer={this.renderer}>
        <Section
          style={{ width: '100%' }}
          flex
          alignSelf='stretch'>
          {this.props.children}
        </Section>
      </Provider>
    )
  }
}

/*
{this.state.grid ? <Grid /> : null}
<MetaData toggleOutlines={this.toggleOutlines} toggleGrid={this.toggleGrid} />
*/



// WEBPACK FOOTER //
// ../containers/FelaProvider.js